import type { CompanyRequestSchemaType } from "@/components/Forms/CompanyForm.tsx";
import { stateAbbreviations } from "@/constants/stateAbbreviations.ts";
import { Button, Grid2 as Grid, MenuItem, Paper, Stack, Typography } from "@mui/material";
import { RhfTextField } from "mui-rhf-integration";
import type { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<CompanyRequestSchemaType>;
};

const CompanyInformation = ({ form }: Props) => {
    return (
        <Grid container>
            <Grid size={12}>
                <Paper
                    sx={{
                        mb: 2,
                        mx: 1,
                    }}
                >
                    <Grid
                        container
                        sx={{
                            borderRadius: "8px",
                            p: 1,
                        }}
                    >
                        <Grid size={12} sx={{ p: 1, mb: 1 }}>
                            <Stack
                                sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography variant={"h5"}>Information</Typography>
                                {form.formState.isDirty && (
                                    <Button
                                        variant="contained"
                                        type={"submit"}
                                        sx={{
                                            p: 1,
                                            borderRadius: "8px",
                                            fontWeight: 800,
                                            mb: 2,
                                            mr: 2,
                                        }}
                                    >
                                        Save
                                    </Button>
                                )}
                            </Stack>
                        </Grid>
                        <Grid size={12} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"name"}
                                label={"Company Name"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                        <Grid size={9} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"address"}
                                label={"Address"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                        <Grid size={3} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"address2"}
                                label={"Apt/Suite"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                        <Grid size={6} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"city"}
                                label={"City"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                        <Grid size={2} sx={{ p: 1 }}>
                            <RhfTextField
                                select
                                control={form.control}
                                name={"state"}
                                label={"State"}
                                sx={{
                                    width: "100%",
                                }}
                            >
                                {stateAbbreviations.map((type) => (
                                    <MenuItem key={`phone-primary-${type}`} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </RhfTextField>
                        </Grid>
                        <Grid size={4} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"zip"}
                                label={"Zip"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                        <Grid size={12} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"website"}
                                label={"Website"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                        <Grid size={6} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"specialty"}
                                label={"Specialty"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                        <Grid size={2} sx={{ p: 1 }}>
                            <RhfTextField
                                select
                                control={form.control}
                                name={"prefered"}
                                label={"Prefered"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            >
                                {["", "Yes", "No"].map((type) => (
                                    <MenuItem key={`phone-primary-${type}`} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </RhfTextField>
                        </Grid>
                        <Grid size={4} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"billingCode"}
                                label={"Billing Code"}
                                sx={{
                                    width: "100%",
                                    mb: 2,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CompanyInformation;
